import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Services from './components/Services/Services';
import Portfolio from './components/Portfolio/Portfolio';
import SuccessStories from './components/SuccessStories/SuccessStories';
import Blog from './components/Blog/Blog';
import Contact from './components/Contact/Contact';
import CallToAction from './components/CallToAction/CallToAction';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <SuccessStories />
      <Blog />
      <CallToAction />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
